module.exports = __webpack_public_path__ + "img/money-bills.5c3a83e7.svg";